// ** Initial State
const initialState = {
  data: [],
  paginationMeta: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
};

const addresses = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_ADDRESSES':
    return {
      ...state,
      data: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };
  default:
    return { ...state };
  }
};
export default addresses;
